import { PLATFORM } from 'aurelia-framework';

export const tabRoutes = [
  {
    route: [''],
    name: 'tab-navision',
    moduleId: PLATFORM.moduleName('./invoice-spagetti-products-tab-navision'),
    tabindex: 0,
    entityShortName: 'invoice-spagetti-products-tab-navision',
  },
  {
    route: ['/delta'],
    name: 'tab-delta',
    moduleId: PLATFORM.moduleName('./invoice-spagetti-products-tab-delta'),
    tabindex: 1,
    entityShortName: 'invoice-spagetti-products-tab-delta',
  },
  {
    route: ['/xledger'],
    name: 'tab-xledger',
    moduleId: PLATFORM.moduleName('./invoice-spagetti-products-tab-xledger'),
    tabindex: 2,
    entityShortName: 'invoice-spagetti-products-tab-xledger',
  },
  {
    route: ['/bcvoninrefa'],
    name: 'tab-bcvoninrefa',
    moduleId: PLATFORM.moduleName('./invoice-spagetti-products-tab-bcvoninrefa'),
    tabindex: 3,
    entityShortName: 'invoice-spagetti-products-tab-bcvoninrefa',
  },
  {
    route: ['/bcfaroeislands'],
    name: 'tab-bcfaroeislands',
    moduleId: PLATFORM.moduleName('./invoice-spagetti-products-tab-bcfaroeislands'),
    tabindex: 4,
    entityShortName: 'invoice-spagetti-products-tab-bcfaroeislands',
  },
];
